import { METRICAS } from "../../lib/site";

export const Numeros = () => {
  return (
    <section
      data-testid="numeros-section"
      className="relative py-20 md:py-28 border-y border-white/5 bg-[#07060c]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <span className="overline">Autoridade</span>
            <h2 className="font-display mt-3 text-2xl md:text-4xl font-medium tracking-tight text-white max-w-xl">
              Um grupo construído sobre execução, consistência e escala.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5 rounded-[24px] overflow-hidden">
          {METRICAS.map((m, i) => (
            <div
              key={m.label}
              data-testid={`metric-${i}`}
              className="relative bg-[#08070d] px-6 py-10 md:px-8 md:py-14"
            >
              <div className="font-display text-5xl md:text-7xl font-light tracking-tight text-white">
                {m.value}
              </div>
              <div className="mt-4 text-sm text-white/75 font-medium">{m.label}</div>
              <div className="mt-1 text-[12px] uppercase tracking-[0.18em] text-white/40">
                {m.sub}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Numeros;
